module.exports = __webpack_public_path__ + "static/media/view-cutoff-time.522bec3d.svg";